<template>
  <main class="app-content">
    <div class="app-title">
      <div>
        <h1><font-awesome-icon icon="database" /> {{ $t('taxCodeInfoTitle') }}</h1>
        <p class="text-muted mb-0">{{ $t('taxCodeInfoDesc') }}</p>
      </div>
    </div>

    <div class="row">
      <div class="col-12">
        <div class="tile">
          <div class="form-inline mb-2">
            <b-form-input class="mr-1 mb-1" v-model="filterFormModel.keyword" v-on:keydown.enter="searchNow"
                          :placeholder="$t('taxCodeInfoKeyword')" style="min-width: 260px"></b-form-input>
            <form-select :model="filterFormModel" attribute="status" class="mr-1 mb-1" :options="[
              {text: $t('all'), value: null},
              {text: $t('taxCodeFound'), value: 'found'},
              {text: $t('taxCodeNotFound'), value: 'notFound'},
            ]"></form-select>
            <button @click="searchNow" class="btn btn-primary mr-1 mb-1">{{ $t('search') }}</button>
            <button @click="resetFilter" class="btn btn-secondary mr-1 mb-1">Reset</button>
          </div>
        </div>
      </div>

      <div class="col-12">
        <div class="c-paging clearfix">
          <div class="c-paging__count" v-if="itemCount">{{ $t('found', [itemCount]) }}</div>
          <div class="c-paging__right">
            <b-pagination v-if="itemCount > filterFormModel.pageSize" class="pull-right" size="sm"
                          v-model="filterFormModel.page" :total-rows="itemCount" :per-page="filterFormModel.pageSize"
                          @input="load"></b-pagination>
          </div>
        </div>
      </div>

      <div class="col-12">
        <div class="tile">
          <div class="table-responsive">
            <table class="table table-hover mb-0">
              <thead>
                <tr>
                  <th>{{ $t('taxCode') }}</th>
                  <th>{{ $t('companyName') }}</th>
                  <th>{{ $t('address') }}</th>
                  <th>{{ $t('status') }}</th>
                  <th>{{ $t('taxCodeState') }}</th>
                  <th>{{ $t('taxCodeFetchedAt') }}</th>
                </tr>
              </thead>
              <tbody>
                <tr v-if="!items.length && !loading">
                  <td colspan="6" class="text-center text-muted py-3">{{ $t('taxCodeNoData') }}</td>
                </tr>
                <tr v-for="item in items" :key="item._id">
                  <td>{{ item.taxCode }}</td>
                  <td>{{ item.name || '—' }}</td>
                  <td>{{ item.address || '—' }}</td>
                  <td>
                    <span v-if="item.status" class="badge"
                          :class="isActive(item) ? 'badge-primary' : 'badge-secondary'">{{ item.status }}</span>
                    <span v-else>—</span>
                  </td>
                  <td>
                    <span class="badge" :class="item.found ? 'badge-success' : 'badge-danger'">
                      {{ item.found ? $t('taxCodeFound') : $t('taxCodeNotFound') }}
                    </span>
                  </td>
                  <td>{{ item.fetchedAt | moment('DD/MM/YYYY HH:mm') }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>
<script>
import List from '@/mixins/List';

export default {
  mixins: [List],
  data() {
    return {
      autoLoad: true,
      service: '/tax-code/list',
      defaultFilterFormModel: {
        page: 1,
        pageSize: 20,
        keyword: null,
        status: null,
      },
    };
  },
  methods: {
    isActive(item) {
      return item.status && item.status.includes('đang hoạt động');
    },
    searchNow() {
      this.filterFormModel.page = 1;
      this.load();
    },
    resetFilter() {
      this.reset();
      this.load();
    },
  },
  i18n: {
    messages: {
      en: {
        taxCodeInfoTitle: 'Tax code lookup',
        taxCodeInfoDesc: 'Business info cached from tax code lookups (source: General Department of Taxation via VietQR).',
        taxCodeInfoKeyword: 'Search by tax code or company name',
        companyName: 'Company name',
        address: 'Address',
        status: 'Status',
        taxCodeState: 'Cache state',
        taxCodeFound: 'Found',
        taxCodeNotFound: 'Not found',
        taxCodeFetchedAt: 'Last fetched',
        taxCodeNoData: 'No cached tax code yet.',
      },
      vi: {
        taxCodeInfoTitle: 'Tra cứu mã số thuế',
        taxCodeInfoDesc: 'Thông tin doanh nghiệp đã cache từ các lượt tra MST (nguồn: Tổng cục Thuế qua VietQR).',
        taxCodeInfoKeyword: 'Tìm theo MST hoặc tên công ty',
        companyName: 'Tên công ty',
        address: 'Địa chỉ',
        status: 'Trạng thái DN',
        taxCodeState: 'Trạng thái cache',
        taxCodeFound: 'Tồn tại',
        taxCodeNotFound: 'Không tồn tại',
        taxCodeFetchedAt: 'Tra lần cuối',
        taxCodeNoData: 'Chưa có MST nào được cache.',
      },
    },
  },
};
</script>
